<template>
  <div class="card">
    <span class="title">{{ reservation.title }}</span>
    <span class="sub-title">อัพเดต {{ updatedAt }}</span>
    <div class="data-container _mgt-8">
      <div class="header">แพ็กเกจ:</div>
      <div class="detail">{{ reservation.package }}</div>
    </div>
    <div class="data-container _mgt-8">
      <div class="header">ระยะเวลา :</div>
      <div class="line-container">
        <div class="detail" v-for="(time, index) in reservation.dates" :key="time+index">{{ time }}</div>
      </div>
    </div>
    <div class="data-container _mgt-8" v-if="reservation.workType !== 'อาศัยกับคนไข้'">
      <div class="header">เวร :</div>
      <div class="detail">{{ reservation.shiftType }}</div>
    </div>
    <div class="data-container _mgt-8">
      <div class="header">รูปแบบ :</div>
      <div class="detail">{{ reservation.workType }}</div>
    </div>
    <div class="data-container _mgt-8">
      <div class="header">สถานที่ดูแล :</div>
      <div class="line-container">
        <div class="detail">{{ reservation.area }}</div>
        <div class="detail" v-if="reservation.address">{{ reservation.address }}</div>
        <a
            class="detail"
            style="text-decoration: underline"
            v-if="reservation.addressLocationUrl"
            :href="reservation.addressLocationUrl"
            target="_blank"
        >ดูแผนที่</a>
        <div class="detail" v-if="reservation.hospital">{{ reservation.hospital }}</div>
        <a
            class="detail"
            style="text-decoration: underline"
            v-if="reservation.hospitalLocationUrl"
            :href="reservation.hospitalLocationUrl"
            target="_blank"
        >ดูแผนที่</a>
      </div>
    </div>
    <div class="data-container _mgt-16">
      <div class="header light">{{ reservation.price.baseLabel }} :</div>
      <div class="detail light">{{ reservation.price.base }}</div>
    </div>
    <div class="data-container _mgt-8">
      <div class="header light">{{ reservation.price.mealLabel }} :</div>
      <div class="detail light">{{ reservation.price.meal }}</div>
    </div>
    <div class="data-container _mgt-8">
      <div class="header light">{{ reservation.price.discountLabel }} :</div>
      <div class="detail light">{{ reservation.price.discount }}</div>
    </div>
    <div class="data-container _mgt-8">
      <div class="header light">ต่างจังหวัด :</div>
      <div class="detail light">{{ reservation.price.zone }}</div>
    </div>
    <div class="data-container _mgt-8">
      <div class="header light">{{ reservation.price.vatLabel }} :</div>
      <div class="detail light">{{ reservation.price.vat }}</div>
    </div>
    <div class="data-container _mgt-8" v-show="reservation.customerType === 'company'">
      <div class="header light">ภาษีหัก ณ ที่จ่าย :</div>
      <div class="detail light">{{ reservation.price.tax }}</div>
    </div>
    <div class="data-container _mgt-8">
      <div class="header light">ราคารวม :</div>
      <div class="detail light">{{ reservation.price.net }}</div>
    </div>
    <div class="data-container hr _mgt-40"></div>
    <div class="data-container _mgt-40">
      <div class="header">สถานะ :</div>
      <div class="detail">{{ reservation.status }}</div>
    </div>
    <div v-if="!reservation.isCancelContinue">
      <div class="data-container _mgt-8">
        <div class="header">การต่อสัญญา :</div>
        <div class="detail">{{ reservation.subscribe }}</div>
      </div>
      <div class="data-container _mgt-8" v-if="reservation.reason !== ''">
        <div class="header">สาเหตุ :</div>
        <div class="detail" v-html="reason"></div>
      </div>
      <div class="data-container _mgt-8" v-if="reservation.reasonDetail !== ''">
        <div class="header">รายละเอียด :</div>
        <div class="detail">{{ reservation.reasonDetail }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
</style>

<style lang="scss" scoped>
  .card {
    background: #FFFFFF;
    padding: 48px 56px;
    display: flex;
    flex-direction: column;

    .title {
      font-family: 'Sukhumvit-Bold';
      line-height: 25px;
      font-size: 22px;
      color: #434B61;
    }

    .sub-title {
      margin-top: 4px;
      font-family: 'Sukhumvit-Medium';
      line-height: 19px;
      font-size: 12px;
      color: #A2A7B3;
      margin-bottom: 16px;
    }

    .data-container {
      display: flex;
      flex-direction: row;

      .header {
        flex: 1;
        font-family: 'Sukhumvit-Bold';
        font-size: 14px;
        line-height: 20px;
        color: #434B61;
        font-weight: 600;
      }

      .detail {
        flex: 1;
        font-family: 'Sukhumvit-Medium';
        font-size: 14px;
        line-height: 20px;
        color: #434B61;
      }

      .line-container {
        display: flex;
        flex-direction: column;
        flex: 1;
      }

      .light {
        color: #A2A7B2 !important;
      }

      &.hr {
        height: 2px;
        width: 100%;
        background: #D5D6DB;
      }

      &._mgt-4 {
        margin-top: 4px;
      }

      &._mgt-8 {
        margin-top: 8px;
      }

      &._mgt-16 {
        margin-top: 16px;
      }

      &._mgt-40 {
        margin-top: 40px;
      }
    }
  }
</style>

<script>
import moment from 'moment'

export default {
  name: 'SectionReservation',
  data () {
    return {
    }
  },
  props: {
    reservation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    updatedAt () {
      return moment(this.reservation.updatedAt).format('DD/MM/YYYY, HH:mm')
    },
    reason () {
      return this.reservation.reason.replace(/\n/g, '<br>')
    },
  },
  methods: {
  },
}
</script>
